import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useUserContext } from '../utils/providers/userContext/useUserContext';

type Req = string | undefined;

interface Return {
  initializeQuiz: (quizId: Req) => Promise<void>;
  isInitializing: boolean;
}

export const useInitializeQuiz = (): Return => {
  const { restUserQuizApi } = useApiClient();
  const { user } = useUserContext();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    mutationFn: async quizId => {
      if (user?.userId && quizId) {
        await restUserQuizApi.initializeUserQuiz(user.userId, quizId);
      }
    },
    mutationKey: [QueryKeyEnum.INITIALIZE_QUIZ],
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: [QueryKeyEnum.PROCESS, user?.userId],
      });
    },
  });

  return { initializeQuiz: mutateAsync, isInitializing: isPending };
};
